import styled from 'styled-components';

export const TermsListContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
